import { createContext } from "react";
import type { TaskWithOccurrences } from "@dashboard/api/task";
import { useContextError } from "common-frontend-components";
import { isAnswered } from "./utils";

const TaskProgressContext = createContext<TaskWithOccurrences[] | null>(null);

function useTaskProgress() {
    return useContextError(TaskProgressContext.name, TaskProgressContext);
}

function countCompleted(tasks: TaskWithOccurrences[]): number {
    return tasks.filter((t) => isAnswered(t.occurrences)).length;
}

export function ProgressBar() {
    const tasks = useTaskProgress();
    const completedTasks = countCompleted(tasks);
    const percentage = tasks.length > 0 ? Math.round((completedTasks / tasks.length) * 100) : 0;
    return (
        <div className="bg-secondary shadow-md min-w-40 w-full">
            <div
                className={`${
                    percentage < 50 ? "bg-error" : percentage < 80 ? "bg-warning" : "bg-success"
                } h-1.5`}
                style={{ width: `${percentage}%` }}
            ></div>
        </div>
    );
}

export function ProgressPercentage() {
    const tasks = useTaskProgress();
    const completedTasks = countCompleted(tasks);
    const percentage = tasks.length > 0 ? Math.round((completedTasks / tasks.length) * 100) : 0;
    return <span>{percentage}%</span>;
}

export function ProgressFraction() {
    const tasks = useTaskProgress();
    const completedTasks = countCompleted(tasks);
    return (
        <div className="min-w-fit whitespace-nowrap">
            {completedTasks} / {tasks.length}
        </div>
    );
}

export function BarWithPercentage() {
    return (
        <div className="">
            <div className="pl-2">
                <ProgressPercentage />
            </div>
            <ProgressBar />
        </div>
    );
}

export function TasksProgress({
    tasks,
    children,
}: {
    tasks: TaskWithOccurrences[];
    children: React.ReactNode;
}) {
    return <TaskProgressContext.Provider value={tasks}>{children}</TaskProgressContext.Provider>;
}
